module.exports = __webpack_public_path__ + "images/assets/17c5a9b625e2ecdcbb984f7c81e9be63.svg";